export default __webpack_public_path__ + "static/media/Pistol_7.e60e7858.png";